import { render, staticRenderFns } from "./index.vue?vue&type=template&id=85f48a1e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=85f48a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f48a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85f48a1e')) {
      api.createRecord('85f48a1e', component.options)
    } else {
      api.reload('85f48a1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=85f48a1e&scoped=true&", function () {
      api.rerender('85f48a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/court/videoCourt/index.vue"
export default component.exports